export const BUSINESS_FILTER_TABS = [
  {
    key: "enabled",
    label: "Active",
    labelKey: "stores.tabs.active",
    color: "text-green-400",
  },
  {
    key: "disabled",
    label: "Inactive",
    labelKey: "stores.tabs.inactive",
    color: "text-red-400",
  },
  {
    key: "all",
    label: "All Stores",
    labelKey: "stores.tabs.all",
    color: "text-white",
  },
];

export const BUSINESS_ITEMS_PER_PAGE = 12;
